<template>
  <section>
    <!-- unitAdmin -->
    <div v-if="userUnitPrivilege.unitAuth === 'unitAdmin'">
      <div
        class="desktop:mb-[10px] mobile:mb-2 cursor-pointer"
        @click="router.replace('/mypage/unit/admin-host-unit-info')"
      >
        유닛
      </div>

      <div class="desktop:text-base mobile:text-sm ml-4">
        <div
          v-for="(item, index) in subMenuByAuth"
          :key="index"
          class="mb-2"
        >
          <router-link :to="`/mypage/unit/${item.path}`">
            {{ t(String(item.name)) }}
          </router-link>
        </div>
      </div>
    </div>

    <!-- groupHost, member, none -->
    <div v-else>
      <div
        class="desktop:mb-[10px] mobile:mb-2 cursor-pointer"
        @click="router.replace('/mypage/unit/admin-host-unit-info')"
      >
        그룹
      </div>

      <div class="desktop:text-base mobile:text-sm ml-4">
        <div
          v-for="(item, index) in subMenuByAuth"
          :key="index"
          class="mb-2"
        >
          <router-link :to="`/mypage/unit/${item.path}`">
            {{ t(String(item.name)) === '유닛관리' ? '그룹관리' : t(String(item.name)) }}
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { routerMypage } from '@/router/children';
import { RouteRecordRaw } from 'vue-router';
import { useComposition } from '@/lib/mypage/useMypage';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
const { userUnitPrivilege } = useComposition();
const router = useRouter();
const { t } = useI18n();

const subMenuByAuth = computed((): RouteRecordRaw[] => {
  const subRouterList: RouteRecordRaw[] = routerMypage.children!.filter((sub) => sub.path === 'unit');
  const adminRouter = subRouterList[0].children!.filter((sub) => sub.path.indexOf('admin') !== -1);
  const hostRouter = subRouterList[0].children!.filter((sub) => sub.path.indexOf('host') !== -1);
  const memberRouter = subRouterList[0].children!.filter((sub) => sub.path.indexOf('unit-info') !== -1);

  return userUnitPrivilege.value.unitAuth === 'unitAdmin'
    ? adminRouter
    : userUnitPrivilege.value.unitAuth === 'groupHost'
    ? hostRouter
    : memberRouter;
});
</script>

<style lang="scss" scoped>
@import '@/assets/style/screens/screen.scss';
.router-link-active {
  @include desktop {
    text-decoration: underline;
    text-underline-position: under;
  }
  @include mobile {
    font-weight: 700;
  }
}
</style>
